// Das Anhang-Feld fuer Aktivitaets- und Aufgaben-Formulare. Nur eine Ueberschrift um
// CompactDocumentUpload herum — die Konstanten stehen in activityDocuments.js, damit
// Anlegen, Bearbeiten und Anzeigen dieselben verwenden.
import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import CompactDocumentUpload from "./CompactDocumentUpload";
import {
  ACTIVITY_DOC_COLLECTION,
  ACTIVITY_DOC_PATH,
  ACTIVITY_DOC_TYPE,
} from "./activityDocuments";

const ActivityDocumentsField = ({ docs, setDocs, companyId, className }) => {
  const { t } = useTranslation(["components", "common"]);
  const { user } = useSelector((state) => ({ user: state.Auth.user }));

  return (
    <Form.Group className={`mb-3${className ? ` ${className}` : ""}`}>
      <Form.Label>{t("Documents")}</Form.Label>
      <CompactDocumentUpload
        setTempDocuments={setDocs}
        documents={docs}
        companyId={companyId || user?.companyId}
        uploadPath={ACTIVITY_DOC_PATH}
        collectionName={ACTIVITY_DOC_COLLECTION}
        documentsFor="activity"
        documentType={ACTIVITY_DOC_TYPE}
        country={user?.country}
      />
    </Form.Group>
  );
};

export default ActivityDocumentsField;
